<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="mb-4">
            <v-col
              cols="12">
              <div
                class="d-flex align-center">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="30">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-2"
                    style="font-weight: 600;">
                    Pelengkap
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6"
              class="pt-0">
              <ValidationProvider 
                name="NPWP" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  NPWP
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  type="number"
                  min="0"

                  :color="set_color"
                  placeholder="Contoh. 00.000.000.0-000.000"

                  hide-details

                  v-model="form.npwp"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.npwp !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="pt-0">
              <ValidationProvider 
                name="BPJS Ketenagakerjaan" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  BPJS Ketenagakerjaan
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  type="number"
                  min="0"

                  :color="set_color"
                  placeholder="Contoh. 324010XXXXXX"

                  hide-details

                  v-model="form.bpjs_tk"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.bpjs_tk !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6">
              <ValidationProvider 
                name="BPJS Kesehatan" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  BPJS Kesehatan
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  type="number"
                  min="0"

                  :color="set_color"
                  placeholder="Contoh. 4292010XXXXXX"

                  hide-details

                  v-model="form.bpjs_kes"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.bpjs_kes !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="6">
              <ValidationProvider 
                name="Jumlah Tanggungan" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Jumlah Tanggungan
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  type="number"
                  min="0"

                  :color="set_color"
                  placeholder="Contoh. 1"

                  hide-details

                  v-model="form.jumlah_tanggungan"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.jumlah_tanggungan !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-divider
            class="my-4"
            style="border-top: 2px dashed #EBEBEB;" />

          <v-row>
            <v-col
              cols="12"
              md="4">
              <ValidationProvider 
                name="Nama Bank" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Nama Bank
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. BRI"

                  hide-details

                  :items="bank"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.account_bank_name"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template 
                    slot="selection" 
                    slot-scope="data">
                    <div
                      class="d-flex align-center">
                      <v-img 
                        contain
                        width="30"
                        height="auto"
                        alt="amanata" 
                        :src="data.item.icon"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="white">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <span 
                        class="text-capitalize ml-3">
                        {{ data.item.text }}
                      </span>
                    </div>
                  </template>

                  <template 
                    slot="item" 
                    slot-scope="data">
                    <div
                      class="d-flex align-center">
                      <v-img 
                        contain
                        width="30"
                        height="auto"
                        alt="amanata" 
                        :src="data.item.icon"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="white">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <span 
                        class="text-capitalize ml-3">
                        {{ data.item.text }}
                      </span>
                    </div>
                  </template>
                  
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.account_bank_name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="4">
              <ValidationProvider 
                name="Nomor Rekening" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Nomor Rekening
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  type="number"
                  min="0"

                  :color="set_color"
                  placeholder="Contoh. 03910XXXX"

                  hide-details

                  v-model="form.account_number"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.account_number !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="4">
              <ValidationProvider 
                name="Atas Nama Rekening" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  
                  Atas Nama Rekening
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. John Doe"

                  hide-details

                  v-model="form.account_name"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.account_name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        bank: [
          {
            text: 'BRI',
            value: 'BRI',
            icon: require('@/assets/bank/bri.png')
          },
          {
            text: 'BNI',
            value: 'BNI',
            icon: require('@/assets/bank/bni.png')
          },
          {
            text: 'Mandiri',
            value: 'Mandiri',
            icon: require('@/assets/bank/mandiri.png')
          },
          {
            text: 'BCA',
            value: 'BCA',
            icon: require('@/assets/bank/bca.png')
          },
          {
            text: 'BSI',
            value: 'BSI',
            icon: require('@/assets/bank/bsi.png')
          },
          {
            text: 'CIMB',
            value: 'CIMB',
            icon: require('@/assets/bank/cimb.png')
          },
          {
            text: 'BTN',
            value: 'BTN',
            icon: require('@/assets/bank/btn.png')
          },
          {
            text: 'Genius',
            value: 'Genius',
            icon: require('@/assets/bank/genius.png')
          },
          {
            text: 'Danamon',
            value: 'Danamon',
            icon: require('@/assets/bank/danamon.png')
          },
          {
            text: 'Bukopin',
            value: 'Bukopin',
            icon: require('@/assets/bank/bukopin.png')
          },
          {
            text: 'Permata',
            value: 'Permata',
            icon: require('@/assets/bank/permata.png')
          }
        ]
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      
    }
  }
</script>